import React from 'react';
import {useTranslation} from 'react-i18next';
import Datepicker from 'react-tailwindcss-datepicker';
import SelectComponent from '../../../Selects/SelectComponent';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

// import { Container } from './styles';

function FiltrosHistoricoPropostas({info}) {
    const {
        //historico de proposta
        filtroId,
        setFiltroId,
        filtroTipoProposta,
        setFiltroTipoProposta,
        filtroDtProposta,
        setFiltroDtProposta,
        filtroCliente,
        setFiltroCliente,
        filtroEstado,
        setFiltroEstado,
        filtroLinhas,
        setFiltroLinhas,
        formattedDate,
        setFormattedDate,
        ids,
        setIds,
        tiposProposta,
        setTiposProposta,
        estados,
        setEstados,
    } = info;

    const {t} = useTranslation();

    function limparFiltros() {
        setFiltroId('');
        setFiltroTipoProposta(null);
        setFiltroEstado(null);
        //setCurrentPage(1);
        setFiltroDtProposta({startDate: null, endDate: null});
    }
    function showButton() {
        if (filtroId || filtroTipoProposta || filtroEstado || filtroDtProposta.startDate) {
            return true;
        } else {
            return false;
        }
    }

    return (
        <div className="dark:bg-gray-800">
            <div className=" mt-2">
                <label htmlFor="first_name" className="block  text-sm font-medium text-gray-900 dark:text-white">
                    {t('id')}
                </label>
                <div className="relative mt-2">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>
                    <input
                        type="search"
                        id="default-search"
                        value={filtroId}
                        className="block w-full p-2 pl-10 text-lg text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder={t('filtro')}
                        onChange={e => {
                            setFiltroId(e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className=" mt-4">
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('tipo')}
                </label>
                <SelectComponent
                    options={tiposProposta}
                    value={filtroTipoProposta ? filtroTipoProposta.label : ''}
                    onChange={e => {
                        setFiltroTipoProposta(e.label);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('filtro')}
                />
            </div>
            <div className=" mt-4">
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('estado')}
                </label>
                <SelectComponent
                    options={estados}
                    value={filtroEstado ? filtroEstado.label : ''}
                    onChange={e => {
                        setFiltroEstado(e.label);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('filtro')}
                />
            </div>

            <div className=" mt-4">
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('data')}
                </label>
                <Datepicker
                    displayFormat="DD/MM/YYYY"
                    useRange={false}
                    asSingle={false}
                    value={filtroDtProposta}
                    onChange={newValue => {
                        setFiltroDtProposta(newValue);
                    }}
                    inputClassName={`rounded-[8px] w-full bg-gray-50 border border-gray-300 text-lg text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                />
            </div>
            {showButton() && (
                <div className="flex flex-row justify-end mt-4">
                    <button
                        type="button"
                        onClick={() => limparFiltros()}
                        className="flex items-center font-semibold text-sm justify-center text-white bg-red-700 rounded-[8px] py-1 px-2 hover:bg-red-800 dark:bg-red-600 dark:hover:bg-red-700 focus:ring-4 focus:ring-red-300 focus:outline-none dark:focus:ring-red-800">
                        {t('limparFiltros')} <CloseRoundedIcon />
                    </button>
                </div>
            )}
        </div>
    );
}

export default FiltrosHistoricoPropostas;
